import React, { useEffect, useState } from "react"
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import { FormGroup, Input, Label, Alert, Row, Col, Button } from "reactstrap"
import createIntent from "../../common/config/createIntent"
import apiHandler from "../../common/config/apiHandler"
import toast from "react-hot-toast"
import SuccessBooking from "../../common/config/success-booking"
import domainUrl from "../../common/config/domainUrl"
import moment from "moment"

const CompleteIncompleteBooking = ({
  siteSubscribeKey,
  formData,
  singleProductData,
  incompleteData,
  userEmail,
  totalAmount,
  setTab,
  bookingData,
  setBookingData,
}) => {
  const [selectedOption, setSelectedOption] = useState("")
  const [paymentOption, setPaymentOption] = useState("")
  const [payment_intent, setPayment_Intent] = useState("")
  const [clientSecret, setClient_Secret] = useState("")
  const [loading, setLoading] = useState(false)
  const stripe = useStripe()
  const elements = useElements()
  const [recipientEmail, setRecipientEmail] = useState(userEmail)
  const [site, setSite] = useState(singleProductData?.site?.web_address)

  const [transactionID, setTransactionID] = useState("")
  const [postalCode, setPostalCode] = useState("")
  const cardElementOptions = {
    style: {
      base: {
        fontSize: "16px",
        color: "#495057",
        "::placeholder": {
          color: "#6c757d",
        },
        backgroundColor: "#fff",
        padding: "12px",
        borderRadius: "5px",
      },
      invalid: {
        color: "#dc3545",
      },
    },
    hidePostalCode: true,
  }

  // const handleCreateIntent = async () => {
  //   if (!stripe || !elements) {
  //     return
  //   }

  //   setLoading(true)
  //   // const amountInCents = Math.round(totalAmount * 100)

  //   try {
  //     if (siteSubscribeKey) {
  //       const paymentIntentResponse = await createIntent({
  //         key: siteSubscribeKey,
  //         amount: totalAmount.toFixed(2),
  //         description: incompleteData?.multi_mode,
          
          
  //       })

  //       if (paymentIntentResponse?.client_secret) {
  //         setLoading(false)
  //         setClient_Secret(paymentIntentResponse?.client_secret)
  //         setPayment_Intent(paymentIntentResponse?.payment_intent)
  //       } else {
  //         setLoading(false)
  //         setClient_Secret("")
  //         setPayment_Intent("")
  //         alert("Failed to create payment intent. Please try again.")
  //       }
  //     }
  //   } catch (error) {
  //     setLoading(false)
  //     console.error("Payment error:", error)
  //     alert(
  //       "Error creating payment intent. Please try again. Error: " +
  //         error.message
  //     )
  //   } finally {
  //     setLoading(false)
  //   }
  // }
  

  const handleCreateIntent = async () => {
    if (!stripe || !elements) {
      return;
    }
  
    setLoading(true);
    // const amountInCents = Math.round(totalAmount * 100)
  
    try {
      if (siteSubscribeKey) {
        // Prepare the parameters for createIntent
        const params = {
          key: siteSubscribeKey,
          amount: totalAmount.toFixed(2),
          description: incompleteData?.multi_mode,
        };
 
        if (singleProductData?.api_tag === "fhr") {
          params.api_tag = singleProductData.api_tag;
        }
  
        const paymentIntentResponse = await createIntent(params);
  
        if (paymentIntentResponse?.client_secret) {
          setLoading(false);
          setClient_Secret(paymentIntentResponse?.client_secret);
          setPayment_Intent(paymentIntentResponse?.payment_intent);
        } else {
          setLoading(false);
          setClient_Secret("");
          setPayment_Intent("");
          alert("Failed to create payment intent. Please try again.");
        }
      }
    } catch (error) {
      setLoading(false);
      console.error("Payment error:", error);
      alert(
        "Error creating payment intent. Please try again. Error: " +
          error.message
      );
    } finally {
      setLoading(false);
    }
  };
  

  const handleOptionChange = value => {
    setSelectedOption(value)
  }

  const handlePaymentOptionChange = e => {
    const selectedOption = e.target.value
    setPaymentOption(selectedOption)

    console.log(selectedOption,"selectedOption")

    if (selectedOption === "stripe-moto") {
      handleCreateIntent()
      
    }
  }

  const handleSubmit = async () => {
    try {
      setLoading(true)

      const user = JSON.parse(localStorage.getItem("user"))

      if (!stripe || !elements) {
        setLoading(false)
        return
      }
      const cardElement = elements.getElement(CardElement)

      const { error: stripeError, paymentIntent } =
        await stripe.confirmCardPayment(clientSecret, {
          payment_method: {
            card: cardElement,
            billing_details: {
              name: `${bookingData?.first_name} ${bookingData?.last_name}`,
              address: {
                postal_code: postalCode,
              },
            },
          },
        })

      if (stripeError) {
        throw new Error(
          `Payment failed. Please try again. Error: ${stripeError.message}`
        )
      }

      if (paymentIntent?.status === "succeeded") {
        const completeResponse = await SuccessBooking({
          key: siteSubscribeKey,
          reference_no: incompleteData?.reference_no,
          company_id: singleProductData?.id,
          payment_type: paymentOption,
          transaction_id: paymentIntent?.id,
          payment_intent_id: paymentIntent?.id,
          user_id: String(user?.id),
        })

        if (completeResponse?.response_code === 200) {
          toast.success("Payment Completed")
          setTab("success-page")
        }
      }
    } catch (error) {
      console.log(error, "error")
      toast.error(
        error.message || "An error occurred while processing the payment."
      )
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleSendEmail = async () => {
    setLoading(true)

    const user = JSON.parse(localStorage.getItem("user"))
    try {
      const response = await apiHandler({
        endpoint2: "/crsbookings/paymentEmail",
        method: "POST",
        data: {
          key: siteSubscribeKey,
          reference_no: incompleteData?.reference_no,
          site_url: site,
          email: recipientEmail,
          future_date: moment().add(1, "days").format("YYYY-MM-DD HH:mm:ss"),
          user_id: String(user?.id),
        },
      })

      if (response?.response_code == 200) {
        toast.success("Email sent successfully!")
        setLoading(false)
      } else {
        toast.error("Failed to send email. Please try again.")
        setLoading(false)
      }
    } catch (error) {
      console.error("Error sending email:", error)
      setLoading(false)
      toast.error("An error occurred while sending the email.")
    }
  }
  const handleTransactionSubmit = async event => {
    event.preventDefault()
    setLoading(true)

    if (!transactionID) {
      toast.error("Transaction ID Needed")
      setLoading(false)
      return
    }

    try {
      const user = JSON.parse(localStorage.getItem("user"))

      const completeResponse = await SuccessBooking({
        key: siteSubscribeKey,
        reference_no: incompleteData?.reference_no,
        company_id: singleProductData?.id,
        payment_type:"stripe-dashboard",
        transaction_id: transactionID,
        payment_intent_id: payment_intent?.id,
        user_id: String(user?.id),
      })

      if (completeResponse?.response_code === 200) {
        toast.success("Payment Completed")
        setTab("success-page")
      }
    } catch (error) {
      console.error("Transaction Error:", error)
      toast.error("An error occurred. Please try again.")
      setLoading(false)
    } finally {
      setLoading(false)
    }
  }

  const handleWorldPay = async () => {
    const user = JSON.parse(localStorage.getItem("user"))

    try {
      setLoading(true)
      const response = await apiHandler({
        endpoint: "/backend/payment/create-worldpay-session",
        method: "POST",
        options: {
          "x-access-token": localStorage.getItem("token"),
        },
        data: {
          type: "addCash",
          key: siteSubscribeKey,
          site_id: singleProductData?.site?.id,
          company_id: singleProductData?.id,
          amount: totalAmount.toFixed(2),
          multi_mode_reference_no: incompleteData?.multi_mode_reference_no,
          reference_no: incompleteData?.reference_no,
          payment_type: paymentOption,
          user_id: String(user?.id),
          name: `${bookingData?.first_name} ${bookingData?.last_name}`,
          email: bookingData?.email,
          contact_no: bookingData?.contact_no,
          notify: `${domainUrl}/worldpay-notify?multi_mode_reference_no=${incompleteData?.multi_mode_reference_no}&reference_no=${incompleteData?.reference_no}`,
          response: `${domainUrl}/worldpay-response?multi_mode_reference_no=${incompleteData?.multi_mode_reference_no}&reference_no=${incompleteData?.reference_no}`,
          cancel: `${domainUrl}/worldpay-cancel?multi_mode_reference_no=${incompleteData?.multi_mode_reference_no}&reference_no=${incompleteData?.reference_no}`,
        },
      })
      if (response) {
        setLoading(false)
        if (typeof window !== "undefined") {
          window.location.href = response?.data?.redirectUrl
          // console.log("host--------------", domainUrl);
        }
      }
    } catch (error) {
      setLoading(false)
      console.log("error", error)
    }
  }

   useEffect(() => {
    if (selectedOption !== "online-payment") {
      setPaymentOption(""); 
    }
  }, [selectedOption]);

  console.log(singleProductData?.api_tag,"incompleteData")

  return (
    <div>
      <Row className="mb-3">
        {singleProductData?.api_tag == "fhr" ? (
      <Col style={{ display: "flex", justifyContent: "center" }}>
      <FormGroup check>
        <Label check>
          <Input
            type="radio"
            name="bookingOption"
            className="border-primary"
            onChange={() => handleOptionChange("online-payment")}
          />{" "}
          Credit / Debit Card
        </Label>
      </FormGroup>
    </Col>
        ) : (
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="bookingOption"
                  className="border-primary"
                  onChange={() => handleOptionChange("online-payment")}
                />{" "}
                Credit / Debit Card
              </Label>
            </FormGroup>
          </Col>
        )}

        <Col style={{ display: "flex", justifyContent: "center" }}>
          <FormGroup check>
            <Label check>
              <Input
                type="radio"
                name="bookingOption"
                className="border-primary"
                onChange={() => handleOptionChange("payment-email")}
              />{" "}
              Create Payment Link
            </Label>
          </FormGroup>
        </Col>
        {singleProductData?.api_tag == "fhr" ? (
          ""
        ) : (
          <Col style={{ display: "flex", justifyContent: "center" }}>
            <FormGroup check>
              <Label check>
                <Input
                  type="radio"
                  name="bookingOption"
                  className="border-primary"
                  onChange={() => handleOptionChange("transaction-id")}
                />{" "}
                Complete Booking
              </Label>
            </FormGroup>
          </Col>
        )}
      </Row>
      {!selectedOption && (
        <Alert color="primary">
          <strong>
            Please Select <em>Payment / Booking</em>
          </strong>{" "}
          To Submit Booking.
        </Alert>
      )}

      {selectedOption === "online-payment" && (
        <>
          <FormGroup>
            <label for="paymentOption">Payment Option:</label>
            <Input
              className="border-secondary"
              type="select"
              name="paymentOption"
              id="paymentOption"
              value={paymentOption}
              onChange={handlePaymentOptionChange}
            >
              <option value="">Select Payment</option>
              <option value="stripe-moto">Stripe Moto</option>
             {singleProductData?.api_tag != "fhr" && <option value="worldpay">WorldPay</option>} 
            </Input>
          </FormGroup>
          {paymentOption === "stripe-moto" && payment_intent && clientSecret ? (
            <div style={{ display: "flex", flexDirection: "column" }}>
              <h5 className="py-3">Stripe Form</h5>
              <div className="my-2 rounded bg-light">
                <CardElement
                  options={cardElementOptions}
                  className="form-control border border-secondary"
                />
                <Input
                  type="text"
                  placeholder="Enter Postal Code"
                  value={postalCode}
                  onChange={e => setPostalCode(e.target.value)}
                  required
                  className="border-secondary mt-3"
                />
              </div>

              <Row style={{ display: "flex", justifyContent: "center" }}>
                <Col md={3} className="mt-2">
                  <Button
                    color="warning"
                    size="sm"
                    onClick={() => {
                      if (paymentOption == "stripe-moto") {
                        handleSubmit()
                      }
                    }}
                    disabled={loading}
                  >
                    {loading
                      ? "Processing..."
                      : paymentOption === "worldpay"
                      ? "World Pay"
                      : "Submit"}
                  </Button>
                </Col>
              </Row>
            </div>
          ) : (
            <Row style={{ display: "flex", justifyContent: "center" }}>
              <Col md={3}>
                <Button
                  color="warning"
                  size="sm"
                  onClick={() => {
                    if (paymentOption == "stripe-moto") {
                      handleSubmit()
                    } else if (paymentOption == "worldpay") {
                      handleWorldPay()
                    } else if (paymentOption == "") {
                      toast.error("Please select any payment option")
                    }
                  }}
                  disabled={loading}
                >
                  {loading
                    ? "Processing..."
                    : paymentOption === "worldpay"
                    ? "World Pay"
                    : "Submit"}
                </Button>
              </Col>
            </Row>
          )}
        </>
      )}

      {selectedOption === "payment-email" && (
        <div>
          <Row>
            <Col md={6}>
              <FormGroup>
                <label htmlFor="recipientEmail">Recipient Email</label>
                <Input
                  type="email"
                  id="recipientEmail"
                  value={recipientEmail}
                  onChange={e => setRecipientEmail(e.target.value)}
                  className="border-secondary"
                  required
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <label htmlFor="message">Site</label>
                <Input
                  type="text"
                  id="message"
                  value={site}
                  onChange={e => setSite(e.target.value)}
                  required
                  className="border-secondary"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row style={{ display: "flex", justifyContent: "center" }}>
            <Col md={2}>
              <Button color="primary" size="sm" onClick={handleSendEmail}>
                {loading ? "Processing..." : "Send Email"}
              </Button>
            </Col>
          </Row>
        </div>
      )}

      {selectedOption === "transaction-id" && (
        <Row className="p-4 d-flex align-items-center ">
          <Col md={6}>
            <Input
              type="text"
              id="transaction_id"
              name="transaction_id"
              placeholder="Transaction ID"
              value={transactionID}
              onChange={e => setTransactionID(e.target.value)}
              required
              className="border-secondary"
            />
          </Col>
          <Col md={3}>
            <Button
              color="primary"
              style={{ width: "100px" }}
              size="sm"
              onClick={handleTransactionSubmit}
            >
              {loading ? "Processing..." : "Submit"}
            </Button>
          </Col>
        </Row>
      )}
    </div>
  )
}

export default CompleteIncompleteBooking
